
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/projects/ezcredit",
      function () {
        return require("private-next-pages/projects/ezcredit.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/projects/ezcredit"])
      });
    }
  